module.exports = __webpack_public_path__ + "static/img/adv_icon1.6c8f9f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruit/adv_icon1.png
// module id = XOqV
// module chunks = 1